import React, { useState } from 'react'
import { Form } from 'react-bootstrap'
import { useForm } from "react-hook-form";
import Red_Btn from '../../common_components/common_btn/red_btn/Red_Btn';
import './Kickstart_Your_Career.css'
import Enquiry_Form_Modal from '../../common_components/common_modal/Enquiry_Form_Modal/Enquiry_Form_Modal';

const Kickstart_Your_Career = () => {

    const [showModal, setShowModal] = useState(false)

    const {
        control,
        register,
        handleSubmit,
        getValues,
        setValue,
        setError,
        clearErrors,
        formState: { errors },
        reset,
        trigger,
    } = useForm();

    return (
      <section className="Kickstart_Your_Career">
        <div className="container">
          <div className="main_div">
            <p className="black_text">
              Kickstart Your Career with the Right Specialization!
            </p>
            <p className="subtext">
              Let’s clear your doubts and guide your path.
            </p>

            <Form className="enquiry_form">
              <div className="input_holder">
                <Form.Group className="form-group">
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Enter your email id for Queries"
                    {...register("name", {
                      required: "Name is required",
                    })}
                  />
                  {errors?.name && (
                    <span className="invalid-feedback d-block">
                      {errors.name.message}
                    </span>
                  )}
                </Form.Group>

                <div className="btn_holder">
                  {/* <Red_Btn btn_name="Inquire Now" onClick={() => { setShowModal(true) }} /> */}
                  <Red_Btn
                    btn_name="Enquire Now"
                    onClick={() =>
                      window.scrollTo({ top: 0, behavior: "smooth" })
                    }
                  />
                </div>
              </div>
            </Form>
          </div>
        </div>

        {/* <Enquiry_Form_Modal
          show={showModal}
          onHide={() => {
            setShowModal(false);
          }}
        /> */}
      </section>
    );
}

export default Kickstart_Your_Career
